<div class="auth-container">
    <div class="auth-content-wrapper" [class.full-width]="isFullWidth">
        <!-- Left Side - Form Content (injected via ng-content) -->
        <div class="auth-form-section">
            <ng-content></ng-content>
        </div>

        <!-- Right Side - Branding -->
        <div class="auth-branding-section" *ngIf="!isFullWidth">
            <div class="placeholder-logo">
                <img src="assets/images/exxon-placeholder.svg" alt="Placeholder" class="placeholder-image">
            </div>
            <div class="branding-content">
                <div class="exxon-logo">
                    <img src="assets/images/exxon-logo.png" alt="ExxonMobil" class="logo-image">
                </div>
                <p class="brand-tagline">{{ 'LOGIN.TAGLINE' | translate }}</p>
            </div>
        </div>
    </div>
</div>